export default "__VITE_ASSET__BSr1l4fU__"